// Add your custom JS here.
(function ($) {

    function MapStyleHoverState(state) {
        layer.setStyle(function (e) {
            let styleProperties = {
                strokeColor: '#595a5c',
                strokeWeight: 1,
                zIndex: 0,
                fillOpacity: 0.0
            };
            projectsData.states.forEach(state => {
                if (e.getProperty('name') == state.state) {
                    styleProperties.strokeColor = '#ec1c2e';
                    styleProperties.zIndex = 1;
                    styleProperties.strokeWeight = 2;
                }
            });
            if (e.getProperty('name') == state) {
                projectsData.states.forEach(thisState => {
                    if (state == thisState.state) {
                        styleProperties.strokeColor = '#ec1c2e';
                        styleProperties.zIndex = 1;
                        styleProperties.strokeWeight = 2;
                        styleProperties.fillOpacity = 1.0;
                        styleProperties.fillColor = '#ec1c2e';
                    }
                });
            }
            return (/** @type {!google.maps.Data.StyleOptions} */styleProperties
            );
        });
    }
    function MapStyleBaseState() {
        layer.setStyle(function (e) {
            let styleProperties = {
                strokeColor: '#595a5c',
                strokeWeight: 1,
                zIndex: 0,
                fillOpacity: 0.0,
                clickable: false
            };
            projectsData.states.forEach(state => {
                if (e.getProperty('name') == state.state) {
                    styleProperties.strokeColor = '#ec1c2e';
                    styleProperties.zIndex = 1;
                    styleProperties.strokeWeight = 2;
                    styleProperties.clickable = true;
                }
            });
            return (/** @type {!google.maps.Data.StyleOptions} */styleProperties
            );
        });
    }
    const marker = (lat, lng, content, zIndex = 1) => {
        return new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            },
            content: content,
            zIndex: zIndex
        });
    };
    var map,
        layer,
        markers,
        page = 0,
        bounds,
        placeBounds,
        mapIds;
    //mapIds = ['a296767eb648e3e3', 'f8bef51e520975cb'];
    window.createMap = function () {
        bounds = new google.maps.LatLngBounds();
        map = new google.maps.Map(document.getElementById("googleMap"), {
            mapId: 'f8bef51e520975cb',
            center: new google.maps.LatLng(39.77331116732558, -104.9924405500464),
            zoom: 12,
            //maxZoom: 9,
            tilt: 0,
            gestureHandling: "none",
            scaleControl: false,
            fullscreenControl: false,
            rotateControl: false,
            streetViewControl: false,
            zoomControl: false,
            mapTypeControl: false,
            keyboardShortcuts: false,
            cameraControl: false,
            mapTypeId: 'roadmap',
            styles: [{
                "stylers": [{}]
            }]
        });
        layer = new google.maps.Data({
            map: map
        });
        markers = [];
        layer.loadGeoJson(xcel_vars.uri + '/inc/usmap.geojson', {}, function (features) {
            layer.forEach(function (feature) {
                projectsData.states.forEach(state => {
                    if (feature.getProperty('name') == state.state) {
                        feature.getGeometry().forEachLatLng(function (coord) {
                            bounds.extend(coord);
                        });
                    }
                });
            });
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 3, bounds.getNorthEast().lng() + 3);
            var extendPoint2 = new google.maps.LatLng(bounds.getSouthWest().lat() - 3, bounds.getSouthWest().lng() - 3);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
            // check if state is set in localstorage
            if (localStorage.getItem("xcel_state") !== null) {
                $('.state-list [data-state="' + localStorage.getItem("xcel_state") + '"]').trigger('click');
                setTimeout(() => { $('#googleMap > div').fadeTo(400, 1.0) }, 400)
            } else {
                setTimeout(() => {
                    map.fitBounds(bounds, {
                        duration: 0.5
                    });
                    setTimeout(() => { $('#googleMap > div').fadeTo(400, 1.0) }, 400)
                }, 100)

            }
            // display pages
            $('.pages > div').each(function () {
                $(this).addClass('display');
            });

            layer.addListener('mouseover', function (e) {
                if (page == 0) MapStyleHoverState(e.feature.getProperty('name'));
            });
            layer.addListener('mouseout', function (e) {
                if (page == 0) MapStyleBaseState();
            });
            layer.addListener('mousedown', function (e) {
                if (page == 0) {
                    MapStyleBaseState();
                    $('.state-list [data-state="' + e.feature.getProperty('name') + '"]').trigger('click');
                }
            });
        });

        MapStyleBaseState();
        // remove tabbing from google maps
        map.addListener("idle", function () {
            setTimeout(function () {
                $('#googleMap').find('*').each(function () {
                    $(this).attr('tabindex', '-1');
                    $(this).attr('aria-hidden', 'true');
                });
            }, 1000)
        });
    };
    var mapScript = document.createElement('script');
    mapScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + xcel_vars.map_key + '&v=weekly&map_ids=f8bef51e520975cb&v=beta&libraries=marker,drawing,geometry,places,visualization&callback=createMap');
    document.body.append(mapScript);
    var decodeEntities = function () {
        // this prevents any overhead from creating the object each time
        var element = document.createElement('div');
        function decodeHTMLEntities(str) {
            if (str && typeof str === 'string') {
                // strip script/html tags
                str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
                str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
                element.innerHTML = str;
                str = element.textContent;
                element.textContent = '';
            }
            return str;
        }
        return decodeHTMLEntities;
    }();


    $(document).ready(() => {
        $('.counter > span:first-child').counterUp({
            time: 1000
        });
        $('.gallery-slide').click(function () {
            let getIndex = $('.gallery-slide').index($(this));
            $('body').append(`
              <div class="interactive-map" tabindex="0">
                  <div class="interactive-map-wrap">
                      <h2 class="d-flex w-100 justify-content-end"><span role="button" tabindex="0" class="close-map"><span>CLOSE</span> ✕</span></h2>
                      <div style="max-width: calc(100vw - 60px);width: 1000px;max-height: calc(100vh - 160px);">${decodeEntities(window['galleryVideo' + (getIndex + 1)])}</div>
                  </div>
              </div>
          `);
            $('.interactive-map').fadeIn(function () {
                setTimeout(() => {
                    $('.interactive-map iframe').focus();
                }, 200)

            });
        });
        $('.interactive-map-button').click(function () {
            let title = $(this).data('title');
            $('body').append(`
              <div class="interactive-map" tabindex="0">
                  <div class="interactive-map-wrap" style="max-width: calc(100vw - 60px);width: 100vw;max-height: calc(100vh - 60px);">
                      <h2>${title} Interactive Map <span role="button" tabindex="0" class="close-map"><span>CLOSE</span> ✕</span></h2>
                      <div class="map-embed" style="max-width: calc(100vw - 60px);width: 1000vw;max-height: calc(100vh - 160px);height: 100vh;">${esriEmbed}</div>
                  </div>
              </div>
          `);
            $('.interactive-map').fadeIn(function () {
                $('.close-map').get(0).focus();
            });
        });
        $(document).on('click', '.close-map', function () {
            $(this).closest('.interactive-map').fadeOut(function () {
                $('.interactive-map').remove();
            });
        });
        $('.gallery-slider').on('init afterChange', function () {
            setTimeout(function () {
                $('.gallery-nav span, .gallery-nav button ').each(function () { $(this).attr('tabindex', 0) });
            }, 0)
        });
        $('.gallery-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true,
            arrows: true,
            adaptiveHeight: true,
            appendDots: $('.dot-nav'),
            prevArrow: $('.gallery-nav .prev-arrow'),
            nextArrow: $('.gallery-nav .next-arrow'),
            accessibility: true,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
        $('.sim-slider').on('init afterChange', function () {
            setTimeout(function () {
                let disableAccess = $('.sim-slide:not(.slick-current) [download], .sim-slide:not(.slick-current) img-comparison-slider');
                let enableAccess = $('.sim-slide.slick-current [download], .sim-slide.slick-current img-comparison-slider');
                /*disableAccess.each(function () {
                    $(this).attr('tabindex', '-1');
                    $(this).attr('aria-hidden', 'true');
                });
                enableAccess.each(function () {
                    $(this).attr('tabindex', '0');
                    $(this).attr('aria-hidden', 'false');
                });*/

            }, 0)
        });
        $('.sim-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: false,
            draggable: false,
            accessibility: false,
            adaptiveHeight: true,
            swipe: false
        });
        $('.sim-slider *').each(function () {
            $(this).attr('tabindex', '-1');
            $(this).attr('aria-hidden', 'true');
        });
        let simNum = $('.sim-nav-slider img').length > 7 ? 7 : $('.sim-nav-slider img').length;
        $('.sim-nav-slider').slick({
            slidesToScroll: 1,
            slidesToShow: simNum,
            dots: false,
            infinite: false,
            asNavFor: '.sim-slider',
            focusOnSelect: true,
            arrows: true,
            prevArrow: $('.sim-slider-controls .prev-arrow'),
            nextArrow: $('.sim-slider-controls .next-arrow'),
            accessibility: true,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
        $('.sim-nav-slider').on('init afterChange', function () {
            $('.sim-slider-controls span').each(function () { $(this).attr('tabindex', 0) });
        });

        $('.sim-slide').on('contextmenu', function () {
            return false;
        });

        /*$('.sim-slide').mousedown(function (e) {
            if (e.which !== 3) return;
            $('.sim-download').text('mouse down');
        }, function () {
            $('.sim-download').text('mouse up');
        })*/

        // Select State and Project
        page = 0;
        /*$('.custom-select').click(function () {
            if ($(this).attr('aria-expanded') == 'false') {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
            $(this).next().slideToggle();
        });*/

        $('.state-list > li').click(function () {
            $(this).attr('aria-selected', 'true');
            $(this).find('a').addClass('active');
            $('.state-list li').not(this).each(function () {
                $(this).attr('aria-selected', 'false');
                $(this).find('a').removeClass('active');
            });
            let stateName = $(this).data('state');
            // store selected state in local storage
            localStorage.setItem('xcel_state', stateName);
            //$(this).parent().slideUp();
            page = 1;
            $('.set-state').text($(this).data('state'));
            $('.state-page-0').hide();
            $('.state-page-1').show();
            projectsData.states.forEach(function (elem, index) {
                if (elem['state'] == stateName) {
                    for (const [key, value] of Object.entries(elem.totals)) {
                        $('.' + key).text(value);
                    }
                    $('.counter > span:first-child').counterUp({
                        time: 1000
                    });
                    $('.project-list').empty();
                    if (elem.project_count > 0) {
                        elem.projects.forEach(function (project) {
                            $('.project-list').append(`
                              <a href="${project.url}">${project.title} <span class="material-symbols-outlined">
                              arrow_right_alt
                          </span></a>
                          `);
                        });
                        $('.explore-map').show();
                    } else {
                        $('.explore-map').hide();
                        $('.project-list').append(`<p style="color: white;">No projects found</p>`);
                    }
                }
            });
        });

        // on state dropdown hover, change style of polygons to simulate hover
        $('.state-list > li').hover(function () {
            let state = $(this).data('state');
            MapStyleHoverState(state);
        }, function () {
            MapStyleBaseState();
        });

        // on state select, move map to markers relevant to that state
        $('.state-list > li').click(function () {
            placeBounds = new google.maps.LatLngBounds();
            let selectedState = $(this).data('state');
            let projectCount = 0;
            projectsData.states.forEach(state => {
                if (selectedState == state.state) {
                    state.projects.forEach((project, index) => {
                        if (project.lat && project.lng) {
                            projectCount++;
                            let extendLatLng = new google.maps.LatLng(project.lat, project.lng);
                            placeBounds.extend(extendLatLng);
                            let html = document.createElement("div");
                            html.classList.add('marker', 'marker-' + index);
                            html.setAttribute('data-index', index);
                            html.style.setProperty('--animation-delay', Math.random() + 's');
                            let name = project.title;
                            html.innerHTML = `<div class="marker-circle"><div class="marker-heading">${name} <span class="material-symbols-outlined">arrow_right_alt</span></div></div>`;
                            let newMarker = marker(project.lat, project.lng, html);
                            markers.push(newMarker);
                        }
                    });

                    // if there are projects for a state, zoom in on state
                    if (state.project_count === 0 || projectCount === 0) {
                        layer.forEach(function (feature) {
                            if (feature.getProperty('name') == selectedState) {
                                feature.getGeometry().forEachLatLng(function (coord) {
                                    placeBounds.extend(coord);
                                });
                            }
                        });
                    }
                    // extend bounds if markers are on the border of view window
                    var extendPoint1 = new google.maps.LatLng(placeBounds.getNorthEast().lat() + 1, placeBounds.getNorthEast().lng() + 1);
                    var extendPoint2 = new google.maps.LatLng(placeBounds.getSouthWest().lat() - 1, placeBounds.getSouthWest().lng() - 1);
                    placeBounds.extend(extendPoint1);
                    placeBounds.extend(extendPoint2);
                    map.fitBounds(placeBounds, {
                        duration: 0.5
                    });
                }
            });
        });
        $(document).on('mouseenter', '.marker', function () {
            $(this).addClass('active');
            $(this).parent().css('z-index', 111111);
        });
        $(document).on('mouseleave', '.marker', function () {
            $(this).removeClass('active');
            setTimeout(() => { $(this).parent().css('z-index', 1); }, 300)
        });
        $(document).on('mouseenter', '.project-list a', function () {
            let getIndex = $('.project-list a').index($(this));
            $('.marker-' + getIndex).addClass('active');
        });
        $(document).on('mouseleave', '.project-list a', function () {
            let getIndex = $('.project-list a').index($(this));
            $('.marker-' + getIndex).removeClass('active');
        });
        $(document).on('click', '.marker', function () {
            let index = parseInt($(this).data('index'));
            $('.project-list a:eq(' + index + ')').get(0).click();
        });
        $('.back').click(function () {
            if ($(this).closest('.state-page-1').length)
                localStorage.removeItem("xcel_state");
            markers.forEach(function (feature) {
                feature.setMap(null);
            });
            markers = [];
            page = 0;
            map.fitBounds(bounds, {
                duration: 0.5
            });
            $('.state-page-1').hide();
            $('.state-page-0').show();
            for (const [key, value] of Object.entries(projectsData.totals)) {
                $('.' + key).text(value);
            }
            $('.counter > span:first-child').counterUp({
                time: 1000
            });
            $('.state-list li').each(function () {
                $(this).attr('aria-selected', 'false');
                $(this).find('a').removeClass('active');
            });

        });

        $('.main-accordion').click(function () {
            $('.sub-accordion').each(function () {
                if ($(this).attr('aria-expanded') == 'true') {
                    $(this).trigger('click');
                }
            });
        });
        /*$('.faq-heading, .faq-heading-small').click(function () {
            $(this).next().slideToggle();
            $(this).toggleClass('active');
            $(this).next().find('.active').removeClass('active').next().slideUp();
            $(this).siblings('.faq-heading, .faq-heading-small').not($(this)).removeClass('active').next().slideUp().find('.active').removeClass('active').next().slideUp();
        });*/

        // handle elements that need enter / space press for accessibility
        $(document).on('keypress', '.slick-arrow:not(.slick-disabled), .home .back, .custom-select, .gallery-slide, .sim-nav-slide, .close-map, .faq-heading, .faq-heading-small', function (e) {
            if (e.keyCode == 13 || e.keyCode == 32) {
                e.preventDefault();
                $(this).trigger('click');
            }
        });

        $('#homelink').click(function (e) {
            e.preventDefault();
            localStorage.removeItem("xcel_state");
            window.location.href = $(this).attr('href');
        });
    });
})(jQuery);